import { useTable } from 'react-table'
import styled from 'styled-components'

export const ReactTable = ({ columns, data, colSpans, rowSpans, cssStyle }: any) => {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  })
  const Styles = styled.div`
    padding: 1rem;
    font-family: 'jioType';
    table {
      border-spacing: 0;
      border: ${cssStyle['-1']?.borderWidth ?? 1}px solid ${cssStyle['-1']?.borderColor ?? 'black'};

      tr {
        :last-child {
          td {
            border-bottom: 0;
          }
        }
      }

      th,
      td {
        margin: 0;
        padding: 0.5rem;
        border-bottom: ${cssStyle['-1']?.borderWidth ?? 1}px solid ${cssStyle['-1']?.borderColor ?? 'black'};
        border-right: ${cssStyle['-1']?.borderWidth ?? 1}px solid ${cssStyle['-1']?.borderColor ?? 'black'};

        :last-child {
          border-right: 0;
        }
      }
    }
  `

  return (
    <Styles>
      <table {...getTableProps()}>
        <thead
          style={{
            color: cssStyle['-1']?.headerTextColor ?? 'black',
            fontSize: cssStyle['-1']?.headerTextSize ?? 16,
            backgroundColor: cssStyle['-1']?.headerBgColor ?? '#00000000',
          }}>
          {headerGroups.map((headerGroup) => {
            return (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  if (typeof column.Header === 'function') {
                    return null
                  }
                  return (
                    <th
                      {...column.getHeaderProps()}
                      colSpan={colSpans['0' + index] ?? 1}
                      style={{ minWidth: 80, textAlign: 'center' }}>
                      <div dangerouslySetInnerHTML={{ __html: column.Header }} />
                    </th>
                  )
                })}
              </tr>
            )
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell, colPosition) => {
                  if (!cell.value) {
                    return null
                  }

                  return (
                    <td
                      {...cell.getCellProps()}
                      rowSpan={rowSpans[i + 1 + '' + colPosition]?.span ?? 1}
                      style={{
                        ...(rowSpans[i + 1 + '' + colPosition]?.span > 1 &&
                        rows.length === i + rowSpans[i + 1 + '' + colPosition]?.span
                          ? { borderBottomWidth: 0 }
                          : {}),
                        ...(cssStyle[i + '']?.backgroundColor && {
                          backgroundColor: cssStyle[i + '']?.backgroundColor,
                        }),
                      }}>
                      <div
                        style={{
                          color: cssStyle['-1']?.dataTextColor ?? 'black',
                          fontSize: cssStyle['-1']?.dataTextSize ?? 16,
                          ...(cssStyle[i + '']?.textColor && { color: cssStyle[i + '']?.textColor }),
                          ...(cssStyle[i + '']?.textSize && { fontSize: parseInt(cssStyle[i + '']?.textSize) }),
                          ...(cssStyle[i + '']?.fontWeight && { fontWeight: cssStyle[i + '']?.fontWeight }),
                        }}
                        dangerouslySetInnerHTML={{ __html: cell.value }}
                      />
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </Styles>
  )
}
